export default {
  title: {
    id: 'sav_platform_issues',
    defaultMessage: 'Problems',
  },
  repairType: {
    id: 'asp_conversation_details_events_repair_type',
    defaultMessage: 'Repair',
  },
  repairCreated: {
    id: 'asp_conversation_details_events_repair_created',
    defaultMessage: 'Created',
  },
  repairReceived: {
    id: 'asp_conversation_details_events_repair_received',
    defaultMessage: 'Received',
  },
  repairDeviceLocked: {
    id: 'asp_conversation_details_events_repair_device_locked',
    defaultMessage: 'Device locked',
  },
  repairDeviceUnlocked: {
    id: 'asp_conversation_details_events_repair_device_unlocked',
    defaultMessage: 'Device unlocked',
  },
  repairOutOfWarranty: {
    id: 'asp_conversation_details_events_repair_out_of_warranty',
    defaultMessage: 'Out of warranty',
  },
  repairRepaired: {
    id: 'asp_conversation_details_events_repair_repaired',
    defaultMessage: 'Repaired',
  },
  repairNotRepaired: {
    id: 'asp_conversation_details_events_repair_not_repaired',
    defaultMessage: 'Not repaired',
  },
  repairShippedToCustomer: {
    id: 'asp_conversation_details_events_repair_shipped_to_customer',
    defaultMessage: 'Shipped to customer',
  },
  noEventDescription: {
    id: 'bo_sellers_customer_care_request_details_events_no_event_description',
    defaultMessage: 'None',
  },
  noEventBody: {
    id: 'bo_sellers_customer_care_request_details_events_no_event_text',
    defaultMessage: 'No customer problems exist for this order.',
  },
}
